export const KEY_PREFIX = 'storage';
export const KEY_SEPARATOR = '$';
